import {
  QUESTION_VALUE_TYPE,
  QUESTION_FILTER_TYPE,
  ONBOARDING_STEPS,
  COLOR_SCHEME_ONBOARDING_STEPS,
  OPEN_TEXT_ONBOARDING_STEPS,
} from '../../../../constants/common';

/**
 * Builds a new `allowedValues` object from the edited answers list,
 * preserving any negative-keyed system entries from the original.
 */
export const buildAllowedValues = (answers, originalAllowedValues = {}) => {
  const next = answers.reduce((acc, item) => {
    acc[item.id] = item.value;
    return acc;
  }, {});

  Object.keys(originalAllowedValues).forEach((key) => {
    if (Number(key) < 0) {
      next[key] = originalAllowedValues[key];
    }
  });

  return next;
};

/**
 * Returns a deep-cloned copy of the dimensions array with the current
 * answers, labels, prompt, and binning configuration applied without mutating the Redux store.
 */
export const buildUpdatedDimensions = ({
  dimensions,
  answers = [],
  labels = [],
  prompt,
  valueType,
  binningConfiguration,
}) => {
  if (!dimensions || !dimensions.length) return dimensions;

  const cloned = dimensions.map((dim) => ({
    ...dim,
    Data: {
      ...dim.Data,
      allowedValues: dim.Data?.allowedValues
        ? { ...dim.Data.allowedValues }
        : dim.Data?.allowedValues,
    },
  }));

  const isMultipleOrGrid = [QUESTION_VALUE_TYPE.MULTIPLE, QUESTION_VALUE_TYPE.GRID].includes(
    valueType
  );

  if (isMultipleOrGrid && labels.length > 0) {
    const sharedAllowedValues =
      answers.length > 0 ? buildAllowedValues(answers, cloned[0].Data?.allowedValues) : null;

    labels.forEach((label, index) => {
      if (!cloned[index]) return;
      if (sharedAllowedValues) {
        cloned[index].Data.allowedValues = { ...sharedAllowedValues };
      }
      cloned[index].Data.label = label.value;
      cloned[index].Data.text = prompt;
    });
  } else {
    cloned[0].Data.allowedValues = buildAllowedValues(answers, cloned[0].Data?.allowedValues);
    if (valueType === QUESTION_VALUE_TYPE.OPEN_TEXT) {
      cloned[0].Data.label = prompt;
      cloned[0].Data.text = prompt;
    }
  }

  if (valueType === QUESTION_VALUE_TYPE.OPEN_NUMERIC && binningConfiguration) {
    const { label, ...binningConfig } = binningConfiguration;
    cloned[0].Data.binningConfiguration = binningConfig;
    cloned[0].Data.description = label;
  }

  return cloned;
};

/**
 * Derives which onboarding step set to show based on the question type
 * and current filter type.
 */
export const resolveOnboardingSteps = (valueType, filterType) => {
  if (valueType === QUESTION_VALUE_TYPE.OPEN_TEXT) {
    return OPEN_TEXT_ONBOARDING_STEPS;
  }
  const showsColorScheme =
    filterType === QUESTION_FILTER_TYPE.ATTRIBUTE ||
    ![QUESTION_VALUE_TYPE.SINGLE, QUESTION_VALUE_TYPE.GRID].includes(valueType);
  return showsColorScheme ? COLOR_SCHEME_ONBOARDING_STEPS : ONBOARDING_STEPS;
};
